import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import Helper from "../Helper";
import { APPLICATION_JSON, DEFAULT_IMAGE_220 } from "../../middleware/types";
import CbLoginModal from "../CbLogin/CbLoginModal";
import { updateProfileDetailsAction } from "../../middleware/updateProfileDetailsAction";
import { useDispatch, useSelector } from "react-redux";
import AddToCartSuccessModal from "./AddToCartSuccessModal";
import useStateRef from "react-usestateref";
import AddShoppingListModalTwo from "./AddShoppingListModalTwo";
import ProductQuickAndIncludeView from "./ProductQuickAndIncludeView";


const ProductQuickViewModal = ({ productObj, solrValue, cartProductDetailsCallBack, cartDetailsCallBack, handleAddToCartAction, isHover, addToCartSuccessFromWhatsInclude }) => {
	const dispatch = useDispatch();
	const [count, setCount] = useState(1);
	const [productQty, setProductQty] = useState('1')
	const [solrProductCount, setSolrProductCount] = useState(solrValue ? solrValue : productObj?.activeFlagCount ? productObj?.activeFlagCount :"")
	console.log('solrProductCount in modal...',solrProductCount ? solrProductCount :'');
	const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
	//const [productObj, setProductObj] = useState(productObj && productObj.familyProduct ? productObj.familyProduct : "")
	const [hasError, setHasError, hasErrorRef] = useStateRef(false);
	const profile = useSelector(state => state.getProfileDetails.profileDetails)
	const [addToCartResponse, setAddToCartResponse, addToCartResponseRef] = useStateRef();
	const [isProductChanged, setIsProductChanged, isProductChangedRef] = useStateRef(false);
	const [triggerModal, setTriggerModal, triggerModalRef] = useStateRef(false);
	const [isHoverState, setIsHoverState, isHoverStateRef] = useStateRef(isHover ? isHover : false);

	function handleChangeCount(event) {
		let value = event.target.value;
		let qty = parseInt(value);
		setCount(qty)
	}

	function handleQuickAddtoWishList(event) {
		console.log("handleQuickAddtoWishList triggered");
		let productId = productObj?.familyProduct?.productId
		let productName = productObj.familyProduct.displayName

		// var modalElement = document.getElementById("loginModal")
		// if(profile && !profile.transient) {
		// 	modalElement = document.getElementById("newListModalww")
		// }
		// //var modalElement = document.getElementById(`${profile && profile.transient ? "loginModal" : "newListModalww"}`);
		// var bootstrapModal = new bootstrap.Modal(modalElement);
		// console.log("modalElement -- ",modalElement);
		// bootstrapModal.show();
		// console.log('bootstrapModal show after',bootstrapModal)
		handleClearErrMsg()
		if (productId) {
			var categoryList = []
			if (productObj?.breadCrumbSchemaJson) {
				let breadDL = productObj?.breadCrumbSchemaJson?.dataLayer_obj;
				const categoryList1 = [breadDL["dataLayer_obj.productSubCat1"] && breadDL["dataLayer_obj.productSubCat1"], breadDL["dataLayer_obj.productSubCat2"] && breadDL["dataLayer_obj.productSubCat2"], breadDL["dataLayer_obj.productSubCat3"] && breadDL["dataLayer_obj.productSubCat3"], breadDL["dataLayer_obj.productSubCat4"] && breadDL["dataLayer_obj.productSubCat4"]];
				categoryList = categoryList1;
			}
			let priceArrCB = [];
			let queryId = `#quickOrderPrice_${productId}`

			let idList = document.querySelectorAll(queryId);
			if (idList) {
				for (let i = 0; i < idList.length; i++) {
					let onePrice = idList[i].innerHTML;
					if (onePrice) {
						priceArrCB.push(onePrice.replace("$", ""))
					}

				}

			}
			let items = [];
			items.push({
				'item_id': productId,
				'item_name': productName,
				'affiliation': '',
				'coupon': '',
				'currency': 'USD',
				'discount': '',
				'index': 0,
				'item_brand': '',
				'item_category': categoryList[0] ? [categoryList[0]] : categoryList[0],
				'item_category2': categoryList[1] ? [categoryList[1]] : categoryList[1],
				'item_category3': categoryList[2] ? [categoryList[2]] : categoryList[2],
				'item_category4': categoryList[3] ? [categoryList[3]] : categoryList[3],
				'item_category5': '',
				'item_list_id': '',
				'item_list_name': '',
				'item_variant': '',
				'location_id': '',
				'price': priceArrCB,
				'quantity': String(count)
			})

			let ecommerce = {
				"items": items
			}
			let ecommerceData = {
				"ecommerce": ecommerce,
				"event": "add_to_wishlist"
			}
			let ecommerceEmptyData = {
				"ecommerce": null
			}
			window.dataLayer = window.dataLayer || []
			if (window.dataLayer.length > 0) {
				window.dataLayer.push(ecommerceEmptyData)
				window.dataLayer.push(ecommerceData)
			}
		}
	}

	const handleClearErrMsg = () => {
		if (document.getElementById("errMsgAlert")) {
			document.getElementById("errMsgAlert").classList.remove("d-block")
			document.getElementById("errMsgAlert").classList.add("d-none")
		}
		if (document.getElementById("eventName")) {
			document.getElementById("eventName").classList.remove("form-error")
		}

	}

	async function handleQuickAddToCart(event) {
		event.preventDefault();
		// var formData = new FormData(event.target);
		// var quantity = formData.get("quantity")
		if (handleAddToCartAction) {
			console.log('handleAddToCartAction')
			handleAddToCartAction(true)
		}
		var actionUrl = "api/rest/cb/cart/plp/add-to-cart";
		if (count == '0') {
			setHasError(true)
			document.getElementById("add-item-error-message").classList.remove("d-none")
			document.getElementById("add-item-error-message").classList.add("d-block")
			document.getElementById("add-item-error-message").innerHTML = "<p>There were no items selected to add to the order.</p>"
		} else if (Helper.isEmpty(count)) {
			setHasError(true)
			document.getElementById("add-item-error-message").classList.remove("d-none")
			document.getElementById("add-item-error-message").classList.add("d-block")
			document.getElementById("add-item-error-message").innerHTML = "<p>Invalid value for a number<br/> There were no items selected to add to the order.</p>"
		} else {
			setHasError(false)
			document.getElementById("add-item-error-message").classList.remove("d-block")
			document.getElementById("add-item-error-message").classList.add("d-none")
			document.getElementById("add-item-error-message").innerHTML = ""
		}
		var prodId = productObj && productObj.productDetails && productObj.productDetails["product.productId"] ? productObj.productDetails["product.productId"] :
			productObj && productObj.familyProduct && productObj.familyProduct.productId ? productObj.familyProduct.productId : ""

		var prodName = productObj && productObj.productDetails && productObj.productDetails["product.productName"] ? productObj.productDetails["product.productName"] :
			productObj && productObj.familyProduct && productObj.familyProduct.productName ? productObj.familyProduct.productName : ""
		const cartDetailMap = {
			addItemCount: count.toString(),
			productId: prodId,
			catalogRefId: prodId,
			quantity: count.toString(),
			organizationId: "",
			courseId: "0"
		}
		if (!hasErrorRef.current) {
			var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
			var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(cartDetailMap))
			var response = JSON.parse(res.response)
			if(isHover){
				addToCartSuccessFromWhatsInclude(res);
				return;
			}
			if (res.result == "success" && response.status == "success") {
				console.log("add-to-cart success...");
				if (cartProductDetailsCallBack) {
					cartProductDetailsCallBack(response.response.response)
				}
				if (cartDetailsCallBack) {
					cartDetailsCallBack(response)
				}

				var categoryList = []
				if (response.response.response.validproducts && response.response.response.validproducts[0]) {
					var productDetails = response.response.response.validproducts[0];
					var dataLayer_obj = response.response.response.validproducts && response.response.response.validproducts[0] && response.response.response.validproducts[0].dataLayer_obj ? JSON.parse(response.response.response.validproducts[0].dataLayer_obj) : ""
					const categoryList1 = [dataLayer_obj["dataLayer_obj.productSubCat1"] && dataLayer_obj["dataLayer_obj.productSubCat1"], dataLayer_obj["dataLayer_obj.productSubCat2"] && dataLayer_obj["dataLayer_obj.productSubCat2"], dataLayer_obj["dataLayer_obj.productSubCat3"] && dataLayer_obj["dataLayer_obj.productSubCat3"], dataLayer_obj["dataLayer_obj.productSubCat4"] && dataLayer_obj["dataLayer_obj.productSubCat4"]];
					categoryList = categoryList1;
					prodName = productDetails["productName"];
				}
				
				setIsProductChanged(true);
				setAddToCartResponse(response.response.response.validproducts ? response.response.response.validproducts[0] : "")
				console.log("addToCartResponseRef...",addToCartResponseRef.current);
				dispatch(updateProfileDetailsAction(true, "cart"));
				handleSiteSpecDataLayer(response?.response);
				handleDataOrder(prodId, prodName, categoryList, productQty)
				document.getElementById("quickViewModalClose").click();
				setTriggerModal(true);
				document.getElementById("hiddenAddToCartSuccessModal").click()
			}
		}
	}

	function handleDataOrder(prodId, prodName, categoryList, productQty) {
		var priceArr = [];
		var items = [];
		items.push({
			'item_id': prodId,
			'item_name': prodName,
			'affiliation': '',
			'coupon': '',
			'currency': 'USD',
			'discount': '',
			'index': 0,
			'item_brand': '',
			'item_category': categoryList[0] ? [categoryList[0]] : "",
			'item_category2': categoryList[1] ? [categoryList[1]] : "",
			'item_category3': categoryList[2] ? [categoryList[2]] : "",
			'item_category4': categoryList[3] ? [categoryList[3]] : "",
			'item_category5': '',
			'item_list_id': '',
			'item_list_name': '',
			'item_variant': '',
			'location_id': '',
			'price': "N/A",
			'quantity': productQty ? productQty : '1'

		})
		let ecommerce = {
			"items": items
		}
		let ecommerceData = {
			"ecommerce": ecommerce,
			"event": "add_to_cart"
		}
		let ecommerceEmptyData = {
			"ecommerce": null
		}
		window.dataLayer = window.dataLayer || []
		if (window.dataLayer.length > 0) {
			window.dataLayer.push(ecommerceEmptyData)
			window.dataLayer.push(ecommerceData)
		}
	}


	function handleSiteSpecDataLayer(response) {
		let categoryList = [];
		let productList = []

		let category = JSON.parse(response?.dataLayer_obj)

		const categoryList1 = [category["dataLayer_obj.productSubCat1"] && category["dataLayer_obj.productSubCat1"], category["dataLayer_obj.productSubCat2"] && category["dataLayer_obj.productSubCat2"], category["dataLayer_obj.productSubCat3"] && category["dataLayer_obj.productSubCat3"], category["dataLayer_obj.productSubCat4"] && category["dataLayer_obj.productSubCat4"]];

		categoryList = categoryList1;
		const productMapDuplicate = {
			"productId": response.response.validproducts[0].ProductId,
			"category": categoryList
		}
		let productMap = productMapDuplicate;
		productList.push(productMap)
		const page = {
			"type": "product",
			"products": productList
		}
		const QUICK_payload = {
			'type': "quick-view",
			"page": page
		}
		window.ssRecsInfo = window.ssRecsInfo || {}
		window.ssRecsInfo = QUICK_payload
		window.dispatchEvent(new CustomEvent("sitespect-user-action", { 'detail': QUICK_payload }))
	}

	function handleQty(event) {
		event.preventDefault()
		var quantity = document.getElementById("quantities").value
		setProductQty(quantity)
	}

	function handleFormEmpty() {
		if (document.getElementById("quickViewAddToCart")) {
			setCount(1)
		}
	}
	useEffect(()=>{
		const modalId = productObj && productObj.familyProduct && productObj.familyProduct.productId ? productObj.familyProduct.productId : productObj && productObj.familyProduct && productObj.familyProduct.famProductId ? productObj.familyProduct.famProductId : "quickViewModal";
		if (document.getElementById(`${modalId}`)) {
			document.getElementById(`${modalId}`).addEventListener('hidden.bs.modal', function (e) {
				setCount(1);
				console.log("count in quick view after closed...",count);
			})
			console.log("count resetted...");
		}
	},[])

	useEffect(() => {
		setSolrProductCount("")
		if (solrValue) {
			setSolrProductCount(solrValue)
		}
	}, [solrValue])

	useEffect(() => {
		handleFormEmpty()
	}, [productObj])

	useEffect(() => {
		console.log("useeffect productObj", productObj);
		handleSiteSpectUserAction(productObj)
	}, [productObj])


	function handleSiteSpectUserAction(productData) {
		if (productData?.breadCrumbSchemaJson) {
			var response = productData?.breadCrumbSchemaJson;

			// handleSiteSpecDataLayer(productData?.breadCrumbSchemaJson,productObj?.familyProduct?.productId)
			// let breadDL = productData?.breadCrumbSchemaJson?.dataLayer_obj;
			// 	const categoryList1 = [breadDL["dataLayer_obj.productSubCat1"] && breadDL["dataLayer_obj.productSubCat1"], breadDL["dataLayer_obj.productSubCat2"] && breadDL["dataLayer_obj.productSubCat2"], breadDL["dataLayer_obj.productSubCat3"] && breadDL["dataLayer_obj.productSubCat3"], breadDL["dataLayer_obj.productSubCat4"] && breadDL["dataLayer_obj.productSubCat4"]];
			// 	categoryList = categoryList1;


			let categoryList = [];
			let productList = []

			let category = response?.dataLayer_obj

			const categoryList1 = [category["dataLayer_obj.productSubCat1"] && category["dataLayer_obj.productSubCat1"], category["dataLayer_obj.productSubCat2"] && category["dataLayer_obj.productSubCat2"], category["dataLayer_obj.productSubCat3"] && category["dataLayer_obj.productSubCat3"], category["dataLayer_obj.productSubCat4"] && category["dataLayer_obj.productSubCat4"]];

			categoryList = categoryList1;
			const productMapDuplicate = {
				"productId": productObj?.familyProduct?.productId,
				"category": categoryList
			}
			let productMap = productMapDuplicate;
			productList.push(productMap)
			const page = {
				"type": "product",
				"products": productList
			}
			const QUICK_payload = {
				'type': "quick-view",
				"page": page
			}
			window.ssRecsInfo = window.ssRecsInfo || {}
			window.ssRecsInfo = QUICK_payload
			window.dispatchEvent(new CustomEvent("sitespect-user-action", { 'detail': QUICK_payload }))
		}
	}

	function isRetailPrice(retialPrice, basePrice) {
		//console.log('retialPrice---- ', retialPrice)
		//console.log('basePrice---- ', basePrice)
		if (retialPrice != null && retialPrice != "$0.00" && basePrice != null && basePrice != "$0.00") {
			if (retialPrice.includes("$")) {
				retialPrice = retialPrice.replace("$", "");
			}
			if (retialPrice.includes(",")) {
				retialPrice = retialPrice.replace(",", "");
			}

			if (basePrice.includes("$")) {
				basePrice = basePrice.replace("$", "");
			}
			if (basePrice.includes(",")) {
				basePrice = basePrice.replace(",", "");
			}
			console.log('democonsole')
			if (parseFloat(retialPrice) > parseFloat(basePrice)) {
				console.log('return true')
				return "true"
			} else {
				console.log('return false')
				return "false"
			}
		} else {
			console.log('return false')
			return "false"
		}


	}


	function replaceImage(event) {
		event.target.src = DEFAULT_IMAGE_220;
	}
	function handleHtmlDescription(description, url) {
		let htmlString = "";
		if(description.includes('<p>')){
			htmlString = `${description}<p><a class="cb-view-link" href=${url}>View Product &gt;</a></p>`
		}else{
			htmlString = `<p>${description}</p><p><a class="cb-view-link" href=${url}>View Product &gt;</a></p>`
		}
		return `${htmlString}`

	}

	function Decrement() {
		if (count > 1) {
			let qty = count - 1;
			setCount(qty);
		}

	}
	function Increment() {
		if (count < 999) {
			let qty = count + 1;
			setCount(qty);
		}
	}




	return (<>
		{console.log("productObj", productObj)}
		<Link id="hiddenAddToCartSuccessModal" aria-current="page" data-bs-toggle="modal" data-bs-target="#addToCartSuccess"></Link>
		<CbLoginModal triggerAddToList={true} isPDP={false} />
		{triggerModalRef.current == true ? <AddToCartSuccessModal productId={addToCartResponseRef.current && addToCartResponseRef.current.ProductId} quantity={addToCartResponseRef.current && addToCartResponseRef.current?.Quantity} productName={addToCartResponseRef.current && addToCartResponseRef.current.productName} isProductChanged={isProductChangedRef.current ? isProductChangedRef.current :false} setIsProductChanged={setIsProductChanged} setTriggerModal={setTriggerModal}/>:<></>}

		<p className="m-0" data-bs-toggle="modal" data-bs-target="#newListModalTwo" onClick={handleClearErrMsg} data-bs-dismiss="modal" id="afterLoginAddToList"></p>
		<AddShoppingListModalTwo pageFrom="quick" quantity={count ? count : 1} productId={productObj && productObj.familyProduct && productObj.familyProduct.productId ? productObj.familyProduct.productId : ""} />
		{!isHoverStateRef.current ?<div className="modal fade c-modal-style c-modal show" id={`${productObj && productObj.familyProduct && productObj.familyProduct.productId ? productObj.familyProduct.productId : productObj && productObj.familyProduct && productObj.familyProduct.famProductId ? productObj.familyProduct.famProductId : "quickViewModal"}`} tabindex="-1" aria-labelledby="loginModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a product-quickview-modal-content">
				<div className="modal-content share-modal">
					<button type="button" class="btn-close " id="quickViewModalClose" data-bs-dismiss="modal" aria-label="Close"></button>
					<div className="modal-body product-quick-view">
						<ProductQuickAndIncludeView productObj={productObj} profileDetails={profileDetails} replaceImage={replaceImage} solrProductCount={solrProductCount ? solrProductCount : productObj?.activeFlagCount ? productObj?.activeFlagCount :''} isRetailPrice={isRetailPrice} handleHtmlDescription={handleHtmlDescription} Decrement={Decrement} Increment={Increment} handleQuickAddToCart={handleQuickAddToCart} handleQuickAddtoWishList={handleQuickAddtoWishList} handleChangeCount={handleChangeCount} count={count} profile={profile} isHover={isHoverStateRef.current}/>
					</div>
				</div>
			</div>
		</div> : 
		
		<div class="includeHoverPosition ">
      <div class="includedQuickViewBox col-12 col-md-11 whats-include-body">
        <div class="includeQuickViewContent">
		<ProductQuickAndIncludeView productObj={productObj} profileDetails={profileDetails} replaceImage={replaceImage} solrProductCount={solrProductCount ? solrProductCount : productObj?.activeFlagCount ? productObj?.activeFlagCount :''} isRetailPrice={isRetailPrice} handleHtmlDescription={handleHtmlDescription} Decrement={Decrement} Increment={Increment} handleQuickAddToCart={handleQuickAddToCart} handleQuickAddtoWishList={handleQuickAddtoWishList} handleChangeCount={handleChangeCount} count={count} profile={profile} isHover={isHoverStateRef.current}/> 
		</div>
        <div class="includeQuickViewarrowUp "></div>
      </div>
    
    </div>
	
		}
		
	</>)
}

export default ProductQuickViewModal
